import { createAsyncThunk } from "@reduxjs/toolkit";
import { setShowError } from "../../Common/Alerts/alertsSlice";
import { getData, postData, putData } from "../../../../services/apiEndpoints";
import { handleError } from "../../Common/Alerts/errorhandling.action";
import { getAY } from "../../../../Utils/academivYear";


export const StudentApplicationThunk = createAsyncThunk(
  "student/application/create",
  async (data, { rejectWithValue ,dispatch }) => {
    try {
      dispatch(setShowError(false));
      const response = await postData(`/application/create-application?say=${data?.say}`, data?.payload);
      return response;
    } catch (error) {
       console.error("Error in Submitting application: ", error);
        handleError(error, dispatch, rejectWithValue);
    }
  }
);

export const fetchStudentApplicationsThunk = createAsyncThunk(
  "student/applications/fetch",
  async (queryParams, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));

      // example: queryParams = { applicantId, applicantType, page, limit, ... }
      const queryString = new URLSearchParams(queryParams).toString();
      const response = await getData(`/application/get-applications?${queryString}`);
      return response;
      
    } catch (error) {
      console.error("Error fetching student applications:", error);
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

export const updateStudentApplicationThunk = createAsyncThunk(
  'applications/updateApplication',
  async ({ applicationId, formData }, { rejectWithValue }) => {
    try {
      const response = await putData(
        `/application/update-application?applicationId=${applicationId}`,
        formData
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Update failed");
    }
  }
);